import { routes } from "@/constants/routes";
import { Redirect } from "expo-router";

/**
 * Pflegeorte liegen unter Meine Pflegestellen.
 * Das Profil enthält keine Pflegeorte-Sektion.
 */
export default function LocationsRedirect() {
  return <Redirect href={routes.myCareSites} />;
}
